import React from 'react'

type Props = {
  ratio: number
  children: React.ReactNode
}

function AspectRatioBox({ ratio, children }: Props) {
  return (
    <div
      className="relative h-0 overflow-hidden"
      style={{ paddingTop: `calc(${ratio} * 100%)` }}
    >
      <div className="absolute left-0 top-0 flex h-full w-full">{children}</div>
    </div>
  )
}

export default AspectRatioBox
